import { createActionGroup, emptyProps } from '@ngrx/store';

export const AuthenticationActions = createActionGroup({
  source: 'Authentication Actions',
  events: {
    'On Logout': emptyProps()
  }
});
